import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-statistic-card',
  standalone: true,
  imports: [RouterLink, TranslateModule],
  templateUrl: './statistic-card.component.html',
  styleUrl: './statistic-card.component.scss'
})
export class StatisticCardComponent {

  @Input() value!: number;
  @Input() description!: string;
  @Input() iconClass!: string;
  @Input() color!: string;
  @Input() type!: string;

  @Output() activeTypeEvent = new EventEmitter<string>();

  activeCard() {
    this.activeTypeEvent.emit(this.type);
  }

}
